{
  "nav": {
    "home": "Home",
    "tutorials": "Tutorials",
    "barcodes": "Barcodes",
    "contact": "Contact us",
    "logout": "Logout",
    "logoAlt": "DinLabel",
    "download": "Download",
    "downloadDemo": "Download demo",
    "buy": "Subscribe",
    "login": "Login",
    "myAccount": "My Account",
    "language": "Language",
    "distributorPortal": "Distributor portal"
  },
  "language": {
    "title": "Language",
    "description": "Choose the language used in the app. By default, your browser language is used.",
    "browser": "Use browser language",
    "english": "English",
    "spanish": "Spanish",
    "german": "German",
    "french": "French"
  },
  "offline": {
    "title": "Offline",
    "message": "The application cannot connect to the server :( !!"
  },
  "dialogs": {
    "apiError": "API Error",
    "confirmYes": "Yes",
    "cancel": "Cancel",
    "send": "Send"
  },
  "portal": {
    "pageTitle": "Distributor portal",
    "actions": "Actions",
    "authorized": "Authorized",
    "pending": "Pending approval",
    "buyLicenses": "Buy licenses",
    "pendingApproval": "Your distributor application has not been approved yet - for any questions, you can contact {{email}}. This process should not take more than 2 business days.",
    "distributorInfo": "Information for distributors",
    "loading": "Loading distributor information…",
    "loadError": "Could not load distributor information."
  },
  "licenses": {
    "noneAvailable": "You currently have no licenses available to send.",
    "statAvailable": "Available to send",
    "statBought": "Purchased",
    "statSent": "Sent",
    "sentHistory": "Licenses sent",
    "activatedYes": "Activated",
    "buyTitle": "Distributor Portal - Buy licenses",
    "buyLoading": "Loading…",
    "buyLoadError": "Could not load distributor information.",
    "buyIntro": "Specify how many licenses you want to buy - the distributor price is {{price}} pesos. Distributors can sell DinLabel however they consider appropriate, but our recommended price is {{recommended}} pesos.",
    "licenseCountLabel": "Number of licenses",
    "costSummary": "The cost of {{count}} licenses is {{cost}} pesos + taxes.",
    "buyButton": "Buy {{count}} licenses",
    "sendTitle": "Send license",
    "resendConfirm": "Do you want to resend the license to {{email}}?",
    "sendPrompt": "Enter the email you want to send to",
    "emailPlaceholder": "email@example.com",
    "errorTitle": "Error!",
    "sendError": "There was an error sending the license {{error}}",
    "resentTitle": "License resent!",
    "resentMessage": "The license has been resent to {{email}} with a copy to {{cc}}",
    "sentTitle": "License sent!",
    "sentMessage": "The license has been sent to {{email}} with a copy to {{cc}}",
    "sendToEmail": "Send license to email...",
    "recipient": "License recipient",
    "date": "Date",
    "sent": "Sent",
    "activated": "Activated",
    "notActivated": "Not yet activated",
    "resend": "Resend license"
  },
  "register": {
    "title": "Become a distributor",
    "intro": "To access the DinLabel distributor portal, you must first register:",
    "company": "Company",
    "companyPlaceholder": "Company name",
    "phone": "Phone",
    "phonePlaceholder": "Phone",
    "phoneDescription": "Make sure to include your country code, for example +52 8183...",
    "street": "Street",
    "street1Placeholder": "Street 1",
    "street2Placeholder": "Street 2",
    "number": "Number",
    "city": "City",
    "state": "State",
    "country": "Country",
    "zip": "ZIP code",
    "rfc": "Tax ID (RFC)",
    "nextSteps": "You will receive an email with the next steps",
    "submit": "Submit"
  },
  "faq": {
    "qGoogleAccount": "Do I need a Google account to be a DINLabel distributor?",
    "aGoogleAccount": "Yes, you need a Google account. If you already have one, you can use it to sign in to the distributor portal.",
    "qRequirements": "What do I need to become a DINLabel distributor?",
    "aRequirementsBefore": "Register as a distributor in the",
    "aRequirementsLink": "distributor portal",
    "aRequirementsAfter": "and wait to receive the confirmation email authorizing you as a DINLabel distributor.",
    "qAnyoneCanSell": "Can any person or company sell DINLabel?",
    "aAnyoneCanSell": "Yes, you only need to register in the DINLabel distributor portal and receive the confirmation email.",
    "qHowManyDistributors": "How many distributors can there be in DINLabel?",
    "aHowManyDistributors": "There is no limit.",
    "qDistributorCost": "How much does a DINLabel license cost a distributor?",
    "aDistributorCost": "112 USD plus taxes per license.",
    "qRecommendedPrice": "What is the recommended retail price from the distributor to their customers for a DINLabel license?",
    "aRecommendedPrice": "The distributor sets the price; there is no fixed price. We suggest a selling price of 160 USD plus taxes. Direct customers on the DinLabel portal subscribe for 15 USD per month plus taxes.",
    "qWhereToBuy": "Where can an end user get DinLabel?",
    "aWhereToBuyBefore": "New customers subscribe monthly on the Subscribe page, or get a license from a distributor. Existing one-time purchasers keep lifetime access. Subscribe on the portal",
    "qHowBuyAsDistributor": "As a distributor, how do I buy DINLabel licenses?",
    "aHowBuyAsDistributorBefore": "Through the Distributor Portal, by going to the Buy Licenses section. See the tutorial",
    "aHowBuyAsDistributorLink": "how to buy licenses.",
    "qMinimumLicenses": "As a distributor, when buying licenses to later sell to my customers, what is the minimum number of licenses I must buy?",
    "aMinimumLicenses": "There is no minimum; you can buy from 1 license.",
    "qHowDeliver": "As a distributor, how do I deliver a DINLabel license to my customer?",
    "aHowDeliverBefore": "Through the distributor portal, in the",
    "aHowDeliverSendLink": "send licenses",
    "aHowDeliverMiddle": " section; see the",
    "aHowDeliverTutorialLink": "tutorial on how to send licenses.",
    "qHowLongPurchase": "How long does it take to buy a license as a distributor and deliver it to the customer?",
    "aHowLongPurchase": "If you are already registered as a distributor, the purchase and license delivery can be done in minutes.",
    "qHowLongToSell": "As a distributor, how long do I have to sell the licenses I purchase in the portal?",
    "aHowLongToSell": "Distributor licenses do not expire. When you buy licenses they are added to your license inventory and you can use them at any time.",
    "qHowManyAvailable": "How can I tell how many licenses I have as a distributor?",
    "aHowManyAvailableBefore": "When you enter the DINLabel",
    "aHowManyAvailableLink": "distributor portal",
    "aHowManyAvailableAfter": ", the first screen shows your balance of licenses available to send.",
    "qSoldLicenses": "How can I tell which licenses I have sold and to whom?",
    "aSoldLicensesBefore": "Through the DINLabel distributor portal in the",
    "aSoldLicensesLink": "view details",
    "qTryBefore": "Can I try DINLabel before becoming a distributor?",
    "aTryBeforeBefore": "Yes, you can download a Demo at",
    "aTryBeforeAfter": "and try it.",
    "qMainFaq": "Are there FAQs (frequently asked questions) on the DINLabel portal?",
    "aMainFaqBefore": "At",
    "aMainFaqAfter": "you will find the most frequent questions about using the DINLabel system.",
    "qTutorials": "Are there tutorials for using DINLabel?",
    "aTutorialsBefore": "At",
    "aTutorialsAfter": "you will find all the tutorials needed to use DINLabel.",
    "qSupport": "As a distributor, do I have technical support?",
    "aSupport": "By email; see the end of this FAQ.",
    "qOtherQuestion": "I have a question that is not on the list. What can I do?",
    "aOtherQuestionBefore": "We would love to help. Go to",
    "aOtherQuestionLink": "contact us",
    "aOtherQuestionAfter": ", send your questions, and we will gladly respond."
  },
  "tutorials": {
    "title": "Tutorials",
    "alsoSeeFaqBefore": "You can also see the",
    "alsoSeeFaqLink": "FAQ",
    "sendLicenseTutorial": "Tutorial: How to send a license from the distributor portal",
    "iframeTitle": "Send license tutorial"
  },
  "home": {
    "welcome": "Welcome, {{email}}",
    "error": "Error"
  },
  "userLicenses": {
    "hasLicense": "You already have full access to DinLabel.",
    "hasSubscription": "Your DinLabel subscription is active.",
    "manageBilling": "Manage billing",
    "noLicense": "You do not have an active DinLabel subscription",
    "buyHere": "Subscribe here"
  },
  "signin": {
    "title": "Sign in",
    "intro": "Sign in with Google or your email and password to continue.",
    "withGoogle": "Sign in with Google",
    "orEmail": "or",
    "email": "Email",
    "password": "Password",
    "withEmail": "Sign in with email",
    "createAccount": "Create an account",
    "forgotPassword": "Forgot password?",
    "emailPasswordError": "Could not sign in. Check your email and password.",
    "agreePrefix": "By continuing you agree to our",
    "privacyLink": "Privacy Policy and Terms of Service",
    "alreadySignedIn": "You are already signed in",
    "signedInAs": "Signed in as {{email}}",
    "continue": "Continue",
    "debugSignInUrl": "Sign-in URL"
  },
  "registerAccount": {
    "title": "Create an account",
    "intro": "Register with your email and a password.",
    "email": "Email",
    "password": "Password",
    "passwordHint": "At least 8 characters",
    "submit": "Create account",
    "haveAccount": "Already have an account?",
    "signIn": "Sign in",
    "error": "Could not create the account.",
    "googleExists": "This email is already registered with Google. Sign in with Google, then add a password in My Account if you want."
  },
  "forgotPassword": {
    "title": "Forgot password",
    "intro": "Enter your email and we will send a reset link if an account exists.",
    "email": "Email",
    "submit": "Send reset link",
    "sent": "If an account exists for that email, a reset link has been sent.",
    "backToSignIn": "Back to sign in",
    "error": "Could not send the reset email."
  },
  "resetPassword": {
    "title": "Reset password",
    "password": "New password",
    "passwordHint": "At least 8 characters",
    "submit": "Update password",
    "success": "Your password has been updated.",
    "signIn": "Sign in",
    "backToSignIn": "Back to sign in",
    "invalidLink": "This reset link is invalid or incomplete.",
    "error": "Could not reset the password."
  },
  "applogin": {
    "title": "Continue in DinLabel",
    "intro": "Continue to finish signing in to the desktop app.",
    "signedInAs": "You're signed in as {{email}}.",
    "continue": "Continue",
    "switchAccount": "Use a different account",
    "redirecting": "Redirecting to sign in…",
    "invalidTitle": "Invalid app login link",
    "invalidBody": "This page is opened by the DinLabel desktop app. Please start sign-in from the application."
  },
  "marketing": {
    "headline": "Professional software for label management and printing",
    "slogan": "Easily set up and print on thermal (Zebra and more), laser, and inkjet printers. Add text, barcodes, variable data, and sequential numbering on fabric, cardstock, or adhesive labels.",
    "featureNumbers": "Sequential numbering & counters",
    "featureImages": "Sharp logos & images",
    "featureVariable": "Variable data, no hassle",
    "featureQr": "Interactive QR codes",
    "featureText": "Clear, readable text",
    "featureBarcode": "Professional barcodes",
    "featureDemo": {
      "productName": "Product name",
      "oliveOil": "Olive Oil",
      "oliveOilDesc": "Description of the olive oil",
      "fontsNote": "Clear, fine, readable fonts",
      "sequence": "Sequence {{n}}",
      "client": "CLIENT:",
      "name": "Name",
      "city": "CITY:",
      "companyLogo": "Company Logo"
    },
    "featuresTitle": "Everything you need on a label",
    "featuresSubtitle": "Build professional labels with the tools print shops and warehouses rely on every day.",
    "seeBarcodeTypes": "See supported barcode types",
    "printersTitle": "Compatible with any printer",
    "printersSubtitle": "DinLabel connects directly to the printers you already use in your business through standard Windows drivers.",
    "printersTypesTitle": "Printer types and media:",
    "printersThermalLabel": "Thermal and Thermal Transfer:",
    "printersThermalBody": "Ideal for adhesive roll labels, Tyvek, nylon, cardboard, and more.",
    "printersLaserLabel": "Laser and Inkjet:",
    "printersLaserBody": "Ideal for adhesive sheet layouts, cardboard, or fabric.",
    "whyTitle": "Why DinLabel?",
    "whyCompatLabel": "Full compatibility:",
    "whyCompatBody": "Print on any printer (thermal, laser, and inkjet) on rolls or sheets.",
    "whyCostLabel": "No inflated costs:",
    "whyCostBody": "All professional features without paying for expensive enterprise licenses.",
    "whySupportLabel": "Real technical support:",
    "whySupportBody": "We help you step by step from download and install through printing your first labels.",
    "tryTitle": "Try DinLabel free today",
    "trySubtitle": "Download the free demo, connect the printer you have (thermal, laser, or inkjet), and see how it prints your labels in minutes.",
    "needHelp": "Need help?",
    "customerService": "Customer service",
    "customerServiceText": "Contact us by email and we will gladly help.",
    "tutorialsText": "Step-by-step video tutorials for every feature."
  },
  "barcodes": {
    "title": "Barcode types in DinLabel",
    "intro": "DinLabel prints the barcode types used most often on retail, shipping, and industrial labels. The types below appear first when you add a barcode. Choose Show more in the editor to use any of the additional types we support.",
    "commonTitle": "Most common barcode types",
    "commonIntro": "These are the types we recommend for most labels. DinLabel supports all of them out of the box.",
    "fullTitle": "All supported barcode types",
    "fullIntro": "The barcode editor lists these names when you choose Show more. Use the same name in DinLabel that you see here.",
    "fullCount": "DinLabel supports {{count}} barcode types.",
    "ctaInstall": "Download DinLabel",
    "ctaTutorials": "Watch barcode tutorials",
    "common": {
      "UpcA": {
        "name": "UPC-A",
        "description": "The 12-digit barcode on most products sold in North America."
      },
      "UpcE": {
        "name": "UPC-E",
        "description": "A compact 6-digit UPC for small packages that cannot fit UPC-A."
      },
      "Ean13": {
        "name": "EAN-13",
        "description": "The 13-digit retail barcode used worldwide, including Europe and Latin America."
      },
      "Ean8": {
        "name": "EAN-8",
        "description": "A shorter EAN for small products that cannot fit EAN-13."
      },
      "Code128": {
        "name": "Code 128",
        "description": "A high-density linear barcode for letters, numbers, and symbols. Common in shipping and inventory."
      },
      "GS1128": {
        "name": "GS1-128",
        "description": "Code 128 with GS1 application identifiers for logistics, GTIN, lot, and date data."
      },
      "Code39": {
        "name": "Code 39",
        "description": "A widely used industrial barcode that encodes letters, numbers, and a few symbols."
      },
      "Interleaved2of5": {
        "name": "Interleaved 2 of 5",
        "description": "A compact numeric barcode used in warehousing, distribution, and industrial labeling."
      },
      "Itf14": {
        "name": "ITF-14",
        "description": "A 14-digit barcode for shipping cartons and outer cases (GTIN-14)."
      },
      "QRCode": {
        "name": "QR Code",
        "description": "A 2D code that stores URLs, text, and more. Easy to scan with a phone."
      },
      "DataMatrix": {
        "name": "Data Matrix",
        "description": "A compact 2D code used in electronics, healthcare, and small parts marking."
      },
      "Pdf417": {
        "name": "PDF417",
        "description": "A stacked 2D barcode that holds more data than typical 1D codes, used on IDs, shipping, and tickets."
      }
    }
  },
  "footer": {
    "tagline": "Professional label design for thermal printers — Zebra and more.",
    "privacy": "Privacy & terms",
    "copyright": "© {{year}} DinLabel"
  },
  "install": {
    "title": "Download",
    "intro": "Install DinLabel on Windows and start designing labels for thermal printers — including Zebra and other Windows label printers — in minutes.",
    "windowsNote": "Windows installer (.exe). Works on Windows 7 and newer.",
    "requirements": "System requirements",
    "reqWindows": "Any Windows version after (Windows 7 and newer)",
    "reqInternet": "Internet access",
    "reqDisk": "50 MB Hard disk storage",
    "freeTag": "Demo version",
    "freeText": "The demo version includes a watermark on printed labels.",
    "paidTitle": "Full version",
    "paidText": "No watermarks — ready for production printing.",
    "buyApp": "Subscribe to DinLabel",
    "orDistributor": "Prefer to subscribe through a partner?",
    "distributorsLink": "View distributors",
    "emailModalTitle": "Download the demo",
    "emailModalIntro": "Enter your email to download the DinLabel demo.",
    "emailLabel": "Email",
    "emailSubmit": "Download",
    "emailInvalid": "Please enter a valid email address.",
    "emailSubmitError": "Something went wrong. Please try again.",
    "thankYouTitle": "Thank you for downloading the DinLabel demo",
    "thankYouIntro": "Your download has started. Here are some resources to help you get started:",
    "thankYouInstall": "How to install DinLabel",
    "thankYouBuy": "How to subscribe to DinLabel",
    "purchasedIntro": "Download and install DinLabel to start using your full version.",
    "signInTitle": "How to sign in",
    "signInStep1": "Download and install DinLabel using the button above.",
    "signInStep2": "Open DinLabel.",
    "signInStep3": "Choose Sign in / register from the menu.",
    "signInStep4": "Sign in with the same account you used to subscribe. Once signed in, you'll be using the full version of DinLabel.",
    "signInStep4UnpurchasedBefore": "Sign in with an account. You'll be using the demo version until you",
    "signInStep4UnpurchasedLink": "subscribe",
    "signInStep4UnpurchasedAfter": "."
  },
  "fullTutorials": {
    "title": "Tutorials",
    "intro": "Step-by-step videos to help you design, print, and get the most out of DinLabel.",
    "howToRoll": "How to create a label on a roll",
    "howToSheet": "How to create a label on a sheet",
    "howTo3Across": "How to create 3-across labels",
    "howToText": "How to add text",
    "howToShapes": "How to add shapes",
    "howToImages": "How to add images",
    "howToBarCodes": "How to add barcodes",
    "howToQR": "How to add QR codes",
    "howToPrint": "How to print",
    "howToConsecutive": "How to use consecutive numbers",
    "howToDataBase": "How to use databases",
    "howToBuy": "How to subscribe to DinLabel",
    "alsoDistributor": "Distributor-specific tutorials are available in the distributor portal.",
    "distributorLink": "Open distributor portal"
  },
  "privacy": {
    "title": "Privacy Policy and Terms of Service",
    "eulaLink": "End User License Agreement",
    "policyLink": "Privacy Policy",
    "note": "The privacy policy opens the localized static HTML document.",
    "loading": "Loading…",
    "eulaLoadError": "Could not load the EULA."
  },
  "distributors": {
    "title": "Distributors"
  },
  "buyPage": {
    "title": "Subscribe to DinLabel",
    "intro": "Unlock the full version with a monthly subscription — no watermarks, ready for thermal and production printing on Zebra and other label printers.",
    "panelTitle": "Monthly subscription",
    "errorTitle": "Something went wrong",
    "thanks": "Thank you for subscribing to DinLabel. You now have full access to the app!",
    "thanksLifetime": "Thank you — you already have lifetime access to DinLabel.",
    "checkAccount": "Check the status of your account",
    "goToDownload": "Go to the download page",
    "manageBilling": "Manage billing",
    "price": "USD ${{price}}/month + Tax",
    "payWithCard": "Subscribe with card",
    "payError": "Could not redirect to Stripe checkout.",
    "adminTestMode": "This is an admin user, so the checkout flow will be using testmode information. Use credit card '4242 4242 4242 4242'.",
    "debugToggleBought": "For admins only: Debug: Toggle Bought (cancels Stripe subscription if any)",
    "toggleBoughtError": "Could not toggle bought state.",
    "orVia": "Prefer another option?",
    "downloadDemo": "Download a fully working demo"
  },
  "userInfo": {
    "title": "My Account",
    "detailsTitle": "Account details",
    "quickLinks": "Quick links",
    "userId": "User ID",
    "email": "Email address",
    "emailConfirmed": "Email confirmed",
    "confirmed": "Confirmed",
    "notConfirmed": "Not confirmed",
    "resend": "Resend",
    "resentEmail": "Confirmation email resent to {{email}}",
    "resendError": "Could not resend confirmation email.",
    "version": "Application version",
    "freeVersion": "Demo version",
    "fullVersion": "Full version",
    "lifetimeAccess": "Lifetime access",
    "subscription": "Subscription",
    "subscriptionTitle": "Subscription",
    "subscriptionStatus": "Status",
    "subscriptionRenews": "Renews on",
    "subscriptionEnds": "Access until",
    "subscriptionCancelScheduled": "Cancels at period end",
    "subscriptionLoading": "Loading subscription…",
    "subscriptionError": "Could not load subscription status.",
    "manageBilling": "Manage billing",
    "statusActive": "Active",
    "statusTrialing": "Trial",
    "statusPastDue": "Past due",
    "statusCanceled": "Canceled",
    "statusUnpaid": "Unpaid",
    "statusIncomplete": "Incomplete",
    "statusIncompleteExpired": "Expired",
    "statusPaused": "Paused",
    "statusUnknown": "{{status}}",
    "buyApp": "Subscribe",
    "accountType": "Account",
    "admin": "Admin portal",
    "openDistributorPortal": "Open distributor portal",
    "setPasswordTitle": "Add a password",
    "setPasswordIntro": "Add a password to sign in with email as well as Google. Your account and license stay the same.",
    "changePasswordTitle": "Change password",
    "changePasswordIntro": "Update the password used for email sign-in.",
    "confirmEmailBeforePassword": "Confirm your email before adding a password.",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "passwordHint": "At least 8 characters",
    "setPasswordExpand": "Add a password",
    "changePasswordExpand": "Change password",
    "passwordFormCancel": "Cancel",
    "setPasswordSubmit": "Save password",
    "changePasswordSubmit": "Update password",
    "passwordSet": "Password saved. You can now sign in with email and password.",
    "passwordChanged": "Password updated.",
    "passwordError": "Could not update the password."
  },
  "myLabels": {
    "title": "My Labels",
    "loading": "Loading…",
    "loadError": "Could not load labels.",
    "empty": "You have no saved labels.",
    "name": "Name",
    "date": "Date",
    "view": "View",
    "download": "Download",
    "back": "Back to my labels"
  },
  "admin": {
    "title": "Admin Portal",
    "dataLink": "DinLabel client analytics dashboard",
    "serverAnalyticsLink": "Server analytics dashboard",
    "fakeEmailLink": "Fake emails",
    "loading": "Loading…",
    "loadError": "Could not load admin data.",
    "totalUsers": "Total users: {{count}}",
    "paidUsers": "Paid users: {{count}}",
    "totalSubscribedUsers": "Total subscribed users: {{count}}",
    "users": "Users",
    "distributors": "Distributors",
    "payments": "Distributor payments",
    "demoDownloaders": "Demo downloaders",
    "authorize": "Authorize",
    "toggleAdmin": "Toggle Admin"
  },
  "fakeEmail": {
    "title": "Fake emails",
    "description": "Preview generated email templates with placeholder data.",
    "distributorSignUp": "Distributor sign-up",
    "activationLink": "Activation / confirm email",
    "sendEmailLicense": "Distributor send license",
    "congratulationEmail": "Congratulations",
    "boughtLicensesMail": "Bought licenses",
    "demoDownloadThankYou": "Demo download thank-you",
    "subject": "Subject",
    "body": "Body",
    "loading": "Loading…",
    "loadError": "Could not load this email.",
    "backAdmin": "Back to admin",
    "testAddress": "Test address",
    "testAddressPlaceholder": "you@example.com",
    "sendTest": "Send test",
    "sendSuccess": "Sent {{action}} to {{email}}",
    "sendError": "Failed to send test email."
  }
}
